// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3eD_k","notes":"Notes_notes__1rhZ-"};